module.exports = __webpack_public_path__ + "static/media/letter_9@3x.ce647513.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_9@3x.png
// module id = 603
// module chunks = 0